/**
 * use navigator.share for sharing links
 * @param title - link title
 * @param link - url
 */
export function shareLink(title: string, link: string): void {
  let navigator: any
  navigator = window.navigator

  if (navigator.share) {
    navigator.share({
      title,
      url: link
    })
      .then(() => console.log('Successful share'))
      .catch(error => console.log('Error sharing', error))
  }
}
